import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";

export class PasswordValidators {
  static defaultValidationConfig = [
    Validators.required,
    Validators.minLength(8),
    PasswordValidators.combinedPatternValidator()
  ]

  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [p: string]: any } | null => {
      if (! control.value) {
        // if the control value is empty return no error.
        return null
      }

      // test the value of the control against the regexp supplied.
      const valid = regex.test(control.value)

      // if true, return no error, otherwise return the error object passed in the second parameter.
      return valid ? null : error
    }
  }

  static combinedPatternValidator(): ValidatorFn {
    return (control: AbstractControl): { [p: string]: any } | null => {
      let matches = 0

      const r_numbers = new RegExp("(?=.*[0-9])")
      const r_uppercase = new RegExp("(?=.*[A-Z])")
      const r_lowercase = new RegExp("(?=.*[a-z])")
      const r_specialchar = new RegExp("(?=.*[$@^!%*?&#§<\\+>)(\\][°\"`´'€@\\-_{}/\\\\\.,;:])")

      matches = matches + (r_numbers.test(control.value) ? 1 : 0)
      matches = matches + (r_uppercase.test(control.value) ? 1 : 0)
      matches = matches + (r_lowercase.test(control.value) ? 1 : 0)
      matches = matches + (r_specialchar.test(control.value) ? 1 : 0)

      return matches > 2 ? null : { requiresAtLeastThreeCriterias: true }
    }
  }

  static matchValidator(control: AbstractControl) {
    if (! control) {
      return null
    }
    const password: string = control.get("password")?.value
    const confirmPassword: string = control.get("confirmPassword")?.value

    if ((! password.length) && (! confirmPassword.length)) {
      control.get("password")?.setErrors(null)
      control.get("confirmPassword")?.setErrors(null)
      return null
    }

    // if the confirmPassword value is null or empty, don't return an error.
    if (! confirmPassword?.length) {
      return null
    }

    // compare the passwords and see if they match.
    if (password != confirmPassword) {
      control.get("confirmPassword")?.setErrors({ mismatch: true })
    } else {
      control.get("confirmPassword")?.setErrors(null)
    }

    return null
  }

  static lengthValidator(control: AbstractControl) {
    if (! control) {
      return null
    }

    const password: string = control.get("password")?.value
    const confirmPassword: string = control.get("confirmPassword")?.value

    if ((! password.length) && (! confirmPassword.length)) {
      control.get("password")?.setErrors(null)
      control.get("confirmPassword")?.setErrors(null)
      return null
    }

    if (password.length < 8 && password.length != 0) {
      control.get("password")?.setErrors({ minlength: true })
    }

    if (confirmPassword.length < 8 && confirmPassword.length != 0) {
      control.get("confirmPassword")?.setErrors({ minlength: true })
    }

    return null
  }

  static requiredPatternValidator(control: AbstractControl) {

    const r_numbers = new RegExp("(?=.*[0-9])")
    const r_uppercase = new RegExp("(?=.*[A-Z])")
    const r_lowercase = new RegExp("(?=.*[a-z])")
    const r_specialchar = new RegExp("(?=.*[$@^!%*?&#§<\\+>)(\\][°\"`´'€@\\-_{}/\\\\\.,;:])")

    const password: string = control.get("password")?.value
    const confirmPassword: string = control.get("confirmPassword")?.value

    if ((! password.length) && (! confirmPassword.length)) {
      control.get("password")?.setErrors(null)
      control.get("confirmPassword")?.setErrors(null)
      return null
    }

    let matches = 0
    matches = matches + (r_numbers.test(password) ? 1 : 0)
    matches = matches + (r_uppercase.test(password) ? 1 : 0)
    matches = matches + (r_lowercase.test(password) ? 1 : 0)
    matches = matches + (r_specialchar.test(password) ? 1 : 0)

    if (matches < 3) {
      control.get("password")?.setErrors({ requiresAtLeastThreeCriterias: true })
    }

    matches = 0
    matches = matches + (r_numbers.test(confirmPassword) ? 1 : 0)
    matches = matches + (r_uppercase.test(confirmPassword) ? 1 : 0)
    matches = matches + (r_lowercase.test(confirmPassword) ? 1 : 0)
    matches = matches + (r_specialchar.test(confirmPassword) ? 1 : 0)

    if (matches < 3) {
      control.get("confirmPassword")?.setErrors({ requiresAtLeastThreeCriterias: true })
    }

    return null
  }

  static removeFormControlError(control: AbstractControl, errorName: string) {
    if (control?.errors && control?.errors[errorName]) {
      delete control.errors[errorName];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }
}
